import React from 'react';
import FieldRow from './FieldRow';

function localeLabel(localeId) {
  if (!localeId) return '?';
  // "en_US" → "EN", "fr_FR" → "FR", "pt_BR" → "PT"
  return localeId.slice(0, 2).toUpperCase();
}

// Renders all locale entries for a localized field.
// Accepts:
//   {key, values: [{localeId, value}]}  — localizedPairs / localizedName shape
//   [{localeId, value}]                 — plain array shape
//   null / undefined                    — renders "—"
export default function LocalizedField({ label, data, fieldKey, diffKeys = new Set(), side }) {
  const isChanged = diffKeys.has(fieldKey);

  const entries = Array.isArray(data)
    ? data
    : Array.isArray(data?.values)
      ? data.values
      : [];

  if (!entries.length) {
    return <FieldRow label={label} value="—" isChanged={isChanged} side={side} />;
  }

  return entries.map((entry) => (
    <FieldRow
      key={entry.localeId ?? entry.locale ?? label}
      label={`${label} (${localeLabel(entry.localeId ?? entry.locale)})`}
      value={entry.value ?? '—'}
      isChanged={isChanged}
      side={side}
    />
  ));
}
